// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * The control itself (.switch / .slider) is styled globally in
 * styles/elements/switchs.scss, which other views also rely on.
 * Only the label wrapper introduced by this component lives here.
 */
.Switch {
    align-items: center;
    display: inline-flex;
    font-weight: normal;
    gap: 8px;
    margin-bottom: 0;
}

.Switch--disabled {
    cursor: not-allowed;
    opacity: 0.6;
}

.Switch__label {
    font-size: 14px;
    line-height: 1;
}
`, "",{"version":3,"sources":["webpack://./js/components/library/html/input/Switch/Switch.css"],"names":[],"mappings":"AAAA;;;;EAIE;AACF;IACI,mBAAmB;IACnB,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,cAAc;AAClB","sourcesContent":["/*\n * The control itself (.switch / .slider) is styled globally in\n * styles/elements/switchs.scss, which other views also rely on.\n * Only the label wrapper introduced by this component lives here.\n */\n.Switch {\n    align-items: center;\n    display: inline-flex;\n    font-weight: normal;\n    gap: 8px;\n    margin-bottom: 0;\n}\n\n.Switch--disabled {\n    cursor: not-allowed;\n    opacity: 0.6;\n}\n\n.Switch__label {\n    font-size: 14px;\n    line-height: 1;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
